import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { ClientFilter } from "src/app/model/client-filter";
import { AuthService } from "src/app/services/auth.service";
import { ClientService } from "src/app/services/client.service";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { LaboratoryTubesService } from "src/app/services/laboratory-tubes/laboratory-tubes.service";

@Component({
  selector: "app-laboratory-tubes-filter",
  templateUrl: "./laboratory-tubes-filter.component.html",
  styleUrls: ["./laboratory-tubes-filter.component.css"],
})
export class LaboratoryTubesFilterComponent
  implements IFilterComponent, OnInit
{
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteClients: FilterCompleteService<ClientFilter>;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private clientService: ClientService,
    private filterRecordService: FilterRecordService,
    private laboratoryTubesService: LaboratoryTubesService
  ) {
    this.form = this.formBuilder.group({
      client: [null],
      patient: [null],
      label: [''],
      dateFrom: [new Date(), Validators.required],
      dateTo: [new Date(), Validators.required],
      viewNoControlled: [true],
      viewRejected: [false],
      viewAcepted: [false],
      viewAll: [false],
    });

    this.filterCompleteClients = new FilterCompleteService<ClientFilter>(
      [],
      this.form.controls.client
    );
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  get filteredClientsOptions() {
    return this.filterCompleteClients
      ? this.filterCompleteClients.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "LaboratoryTubesFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "LaboratoryTubesFilterComponent",
      this.form
    );
  }

  async ngOnInit() {
    const info = await this.clientService.getClientFilters();
    this.filterCompleteClients = new FilterCompleteService<ClientFilter>(
      info,
      this.form.controls.client
    );
  }

  async search(): Promise<any> {
    try {
      if (this.form.valid) {
        return this.laboratoryTubesService.get(
          this.form.controls.dateFrom.value,
          this.form.controls.dateTo.value,
          this.form.controls.viewNoControlled.value,
          this.form.controls.viewRejected.value,
          this.form.controls.viewAcepted.value,
          this.form.controls.label.value,
          this.form.controls.client.value
            ? this.form.controls.client.value.Id
            : null,
          this.form.controls.patient.value
            ? this.form.controls.patient.value.Id
            : null
        );
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }
}
